/**
 * The dot's colour for what someone typed as a vehicle's colour, or nothing
 * for a word this does not know: it is free text, and a wrong dot says more
 * than no dot. The last word decides, so "Dark Blue" is blue. CSS's names
 * rather than tokens: these are the colours of the car, not the product, and
 * they stay the same in light and dark.
 */
const SWATCHES: Record<string, string> = {
  beige: 'beige',
  black: 'black',
  blue: 'royalblue',
  bronze: 'peru',
  brown: 'saddlebrown',
  burgundy: 'maroon',
  charcoal: 'darkslategray',
  gold: 'goldenrod',
  gray: 'gray',
  green: 'seagreen',
  grey: 'gray',
  maroon: 'maroon',
  navy: 'navy',
  orange: 'darkorange',
  pink: 'hotpink',
  purple: 'rebeccapurple',
  red: 'firebrick',
  silver: 'silver',
  tan: 'tan',
  teal: 'teal',
  white: 'white',
  yellow: 'gold',
};

export function vehicleColorSwatch(
  color: string | null | undefined
): string | undefined {
  const word = color
    ?.toLowerCase()
    .match(/[a-z]+/g)
    ?.at(-1);
  return word ? SWATCHES[word] : undefined;
}
